/* Shipping amounts use their native rate currency, independently of product markups. */
(() => {
  const config = document.currentScript;
  const currency = config?.dataset.currency;
  const base = config?.dataset.baseCurrency;
  const locale = document.documentElement.lang || 'fr';
  function refresh() {
    const fx = currency === base ? 1 : Number(window.Shopify?.currency?.rate);
    if (!currency || !Number.isFinite(fx) || fx <= 0) return;
    const formatter = new Intl.NumberFormat(locale, {style: 'currency', currency});
    const precision = formatter.resolvedOptions().maximumFractionDigits;
    const scale = 10 ** precision;
    document.querySelectorAll('[data-curling-shipping-money]').forEach(node => {
      const source = node.dataset.curlingShippingCurrency || base;
      const conversion = source === currency ? 1 : source === base ? fx : null;
      if (conversion === null) return;
      const amount = Number(node.dataset.curlingShippingMoney);
      if (!Number.isFinite(amount)) return;
      // Never advertise free delivery below the converted qualifying amount.
      const converted = node.hasAttribute('data-curling-threshold')
        ? Math.ceil((amount * conversion - 1e-9) * scale) / scale
        : Math.round(amount * conversion * scale) / scale;
      const text = formatter.format(converted);
      if (node.textContent !== text) node.textContent = text;
      node.hidden = false;
      node.closest('[data-curling-currency-content]')?.removeAttribute('hidden');
    });
  }
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; refresh(); });
  };
  new MutationObserver(schedule).observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('DOMContentLoaded', refresh, {once:true});
  document.addEventListener('cart:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  refresh();
})();
